import { hooks as fusion } from './fusion/fusionApi';
import { hooks as atlas } from './atlas/atlasApi';

const queries = {
  fusion,
  atlas,
};

export default queries;
